/**
* @file 资源管理-司机资源
* */
<template>
  <div id="driver">
    <custom-table
      ref="customTable"
      addText="创建员工"
      has-organization="true"
      :customOptions="customOptions"
      :columns="columns"
      @addFn="addFn"
    >
      <template slot="table-operation">
        <el-table-column label="操作" width="150" fixed="right">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text" @click="edit(row)">编辑</el-button>
            <el-button type="text" style="color: #ff0000" @click="del(row)">删除</el-button>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{ item, row }">
        <template
          v-if="['created', 'auditTime', 'lastLoginTime'].includes(item.prop)"
          >{{ row[item.prop] | filterTime }}
        </template>
        <template v-else-if="item.prop === 'status'">
          <el-switch
            class="tableScopeSwitch"
            v-model="row.status"
            :active-value="1"
            :inactive-value="2"
            active-text="启用"
            inactive-text="停用"
            @change="updateStatus($event, row)"
          >
          </el-switch>
        </template>
        <div v-else-if="item.prop === 'name'" class="avatar-name">
          <span>{{ row.name }}</span>
          <el-tag type="info" style="margin-left: 5px;">{{ row.type | filterCzAccountType }}</el-tag>
        </div>
        <template v-else-if="item.prop === 'balance'">
          <span class="util-money">￥{{ (row.balance + row.noBalance).toFixed(2) }}</span>
        </template>
        <template v-else>
          <span>{{ row[item.prop] ? row[item.prop] : "-" }}</span>
        </template>
      </template>
    </custom-table>

    <el-dialog
      title="员工信息"
      :before-close="handClose"
      :visible.sync="accountInfoShow"
      destroy-on-close
      width="500px"
    >
      <el-form :model="form" :rules="rules" ref="infoForm" label-width="80px">
        <el-form-item label="机构名称" prop="organizationId">
          <el-select
            clearable
            v-model="form.organizationId"
            placeholder="请选择机构名称"
            :disabled="id"
          >
            <el-option v-for="item in organizations" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="员工姓名" prop="name">
          <el-input v-model="form.name" maxlength="15" placeholder="请输入员工姓名" @input="removeSpaces($event, 'name')"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="phone">
          <el-input v-model="form.phone" maxlength="11" placeholder="请输入手机号码" @input="removeSpaces($event, 'phone')"></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="password">
          <el-input v-model="form.password" type="password" autocomplete="new-password" maxlength="12" placeholder="请输入登录密码" @input="removeSpaces($event, 'password')"></el-input>
        </el-form-item>
        <el-form-item label="员工类型" prop="type">
          <el-radio-group v-model="form.type" :disabled="id">
            <el-radio
              v-for="item in $const.CZACCOUNTTYPE"
              :key="item.value"
              :label="item.value"
            >
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handClose">取消</el-button>
        <el-button type="primary" :loading="loading" @click="handSure">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "driver",
  components: {},
  data() {
    const validateName = (rule, value, callback) => {
      let reg = /^.{2,15}$/;
      if (value === "") {
        callback(new Error("请输入员工姓名"));
      } else {
        if (!reg.test(value)) {
          callback(new Error("请输入2-15位员工姓名"));
        }
        callback();
      }
    };
    const validatePhone = (rule, value, callback) => {
      let reg = /^1[3-9]\d{9}$/;
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else {
        if (!reg.test(value)) {
          callback(new Error("请输入正确的手机号码"));
        }
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      let reg = /^.{6,12}$/;
      if (value === "") {
        callback(new Error("请输入登录密码"));
      } else {
        if (!reg.test(value)) {
          callback(new Error("请输入6-12位登录密码"));
        }
        callback();
      }
    };
    return {
      id: null,
      loading: false,
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/airport/account",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {
            type: "input",
            field: "name",
            name: "员工姓名",
            value: "",
          },
          {
            type: "input",
            field: "phone",
            name: "员工手机号",
            value: "",
          },

          // {
          //   type: "select",
          //   field: "status",
          //   name: "账号状态",
          //   value: "",
          //   option: [
          //     { value: 1, label: "启用状态" },
          //     { value: 2, label: "停用状态" },
          //   ],
          // },
          {
            type: "select",
            field: "type",
            name: "员工类型",
            value: "",
            option: this.$const.CZACCOUNTTYPE,
            clearable: true,
            filterable: true,
          },
        ],
      },
      columns: [
        { prop: "name", label: "员工姓名" },
        { prop: "phone", label: "手机号码" },
        { prop: "balance", label: "钱包余额" },
        { prop: "status", label: "账号状态" },
      ],
      accountInfoShow: false,
      form: {
        organizationId: null,
        name: null,
        phone: null,
        type: null,
        password: null,
      },
      rules: {
        organizationId: [
          { required: true, message: "请选择机构名称", trigger: "change" },
        ],
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { validator: validateName, trigger: "blur" },
        ],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }, { validator: validatePhone, trigger: "blur" }],
        password: [{ required: true, message: "请输入登录密码", trigger: "blur" },{ validator: validatePassword, trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
      },
    };
  },
  computed: {},
  async created() {
    await this.mixinOrganizations();
  },
  methods: {
    removeSpaces(value, key) {
      this.form[key] = value.replace(/\s+/g, "");
    },
    // 关闭弹窗
    handClose() {
      this.id = null;
      this.accountInfoShow = false;
      this.form = {
        organizationId: null,
        name: null,
        phone: null,
        type: null,
        password: null,
      };
    },

    /**
     * 点击创建员工
     */
    addFn() {
      this.accountInfoShow = true;
      this.rules.password[0].required = true;
    },
    // 更换员工状态
    async updateStatus(status, row) {
      let text = status == 1 ? "是否确认启用员工账号？" : "是否确认停用员工账号？";
      let title = status == 1 ? "启用账号" : "停用账号";
      this.$confirm(text, title)
        .then(async () => {
          let url = "/api/v1/manage/airport/account";
          let params = {
            id: row.id,
            status: status,
          };
          let data = await this.$axios.put(url, params);
          if (data && data.code === 1) {
            this.$message.success("操作成功");
            this.$refs.customTable.listFn();
          }else {
            row.status = status == 1 ? 2 : 1;
          }
        })
        .catch(() => {
          row.status = status == 1 ? 2 : 1;
        });
    },
    /**
     * 列表-删除
     */
    async del(row) {
      this.$confirm("是否确认删除员工账号？", "删除账号").then(async () => {
        let url = "/api/v1/manage/airport/account";
        let params = {
          id: row.id,
        };
        let data = await this.$axios.delete(url, params);
        if (data && data.code === 1) {
          this.$message.success("删除成功");
          this.$refs.customTable.listFn();
        }
      });
    },
    /**
     * 列表-编辑
     */
    edit(row) {
      this.id = row.id;
      this.rules.password[0].required = false;
      this.form = {
        organizationId: row.organizationId,
        name: row.name,
        phone: row.phone,
        type: row.type,
      }
      this.accountInfoShow = true;
    },
    // 弹窗提交
    handSure() {
      this.$refs.infoForm.validate(async (valid) => {
        if(valid) {
          let url = "/api/v1/manage/airport/account";
          let params = {
            ...this.form
          };
          if(this.id) {
            params.id = this.id;
          }
          if (params.password) {
            params.password = this.$utils.sha256Fn(params.password);
          }
          this.loading = true;
          let query = null;
          if(this.id) {
            const { code } = await this.$axios.put(url, params);
            query = code;
          }else {
            const { code } = await this.$axios.post(url, params);
            query = code;
          }
          
          if(query == 1) {
            this.$message.success("操作成功");
            this.handClose();
            this.$refs.customTable.listFn();
          }
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style lang="less">
#driver {
  .avatar-name {
    display: flex;
    align-items: center;
  }

  .tableScopeSwitch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff;
  }
  .el-switch__label * {
    font-size: 12px !important;
  }
  /*打开时文字位置设置*/
  .tableScopeSwitch .el-switch__label--right {
    z-index: 1;
    right: -6px; /*不同场景下可能不同，自行调整*/
  }
  /*关闭时文字位置设置*/
  .tableScopeSwitch .el-switch__label--left {
    z-index: 1;
    left: 20px; /*不同场景下可能不同，自行调整*/
  }
  /*显示文字*/
  .tableScopeSwitch .el-switch__label.is-active {
    display: block;
  }
  .tableScopeSwitch.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 50px !important; /*开关按钮的宽度大小*/
  }
}
</style>
